import { continueActionTypes as act } from './continueActionTypes';

export default function transferAccount(state = { account: '' }, action) {
  switch (action.type) {
    case act.ACCOUNT: {
      return {
        ...state,
        account: action.payload,
      };
    }
    case act.AMOUNT: {
      return {
        ...state,
        amount: action.payload,
      };
    }
    case act.TRANSFER: {
      return {
        ...state,
        transfer: action.payload,
      };
    }
    case act.PARTIALTRANSFER: {
      return {
        ...state,
        partialtransfer: action.payload,
      };
    }
    default:
      return state;
  }
}
